import React from 'react';
import { AlertTriangle, CreditCard } from 'lucide-react';
import Button from './Button';
import { useSubscriptionError } from '../../context/SubscriptionErrorContext';

const SubscriptionErrorBanner: React.FC = () => {
  const { subscriptionError, clearSubscriptionError } = useSubscriptionError();

  if (!subscriptionError) {
    return null;
  }

  return (
    <div className="mb-6 p-4 rounded-lg border bg-red-900/20 border-red-500/50 text-red-300 flex items-start gap-3">
      <AlertTriangle className="w-5 h-5 mt-0.5 flex-shrink-0" />
      <div className="flex-1">
        <h4 className="font-bold text-red-200 mb-1">{subscriptionError.userTitle}</h4>
        <p className="text-sm mb-3">{subscriptionError.userMessage}</p>
        <div className="flex gap-3">
          <Button
            variant="primary"
            size="sm"
            onClick={() => window.location.href = '#/subscriptions'}
            className="flex items-center gap-2"
          >
            <CreditCard className="w-4 h-4" />
            Update Subscription
          </Button>
          <Button
            variant="secondary"
            size="sm"
            onClick={clearSubscriptionError}
          >
            Dismiss
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionErrorBanner;